import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/bottlesSimple'
import { dialogTypes } from 'dialogs'
import Content from './grid'
import Form from './form'
import { default as AboveContent } from './filters'

import { urls } from 'urls'

const PAGE = 'bottlesSimple'

export const metadata = {
  icon: 'glass',
  page: PAGE,
  urls: urls[PAGE],
  isSoftDelete: false,
  hideCreate: true,
  hideDelete: true,
  detailDialog: dialogTypes.bottleSimpleDetail,
  useDetailDialog: true
}

const BottlesSimpleListPage = createListPage({ metadata, api, actionCreators, Content, AboveContent })
const BottlesSimpleDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { BottlesSimpleListPage, BottlesSimpleDetailPage }
